// The "C" mark from public/logo.svg, inlined so it can render at text size in currentColor.
export const CounselProMark = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 29 30"
    fill="currentColor"
    aria-hidden="true"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7534 0C20.7367 0 25.8881 3.62132 28.2031 8.82585L22.8172 11.2826C21.4258 8.16607 18.3381 5.99861 14.7526 5.99861C9.8637 5.99861 5.90049 10.0281 5.90049 14.9986V15.0007V27.0005C2.31754 24.2639 0 19.9071 0 15C0 6.71576 6.60534 0 14.7534 0ZM22.8442 18.6536L28.2311 21.1108C25.93 26.3493 20.761 30.0001 14.7534 30.0001C13.4795 30.0001 12.2433 29.8359 11.0642 29.5273V23.1826C12.187 23.7066 13.4362 23.9987 14.7526 23.9987C18.3615 23.9987 21.4661 21.8028 22.8442 18.6536ZM14.756 18.7507C16.793 18.7507 18.4443 17.0718 18.4443 15.0007C18.4443 12.9296 16.793 11.2507 14.756 11.2507C12.7189 11.2507 11.0676 12.9296 11.0676 15.0007C11.0676 17.0718 12.7189 18.7507 14.756 18.7507Z"
    />
  </svg>
)
